import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header"]

  connect() {
    this.checkVisibility()
    this.observeDocuments()
  }

  observeDocuments() {
    // Find the turbo frame containing documents
    const turboFrame = this.element.closest('.files-container')?.querySelector('[id^="dossier_documents_"]')

    if (turboFrame) {
      this.observer = new MutationObserver(() => {
        this.checkVisibility()
      })

      this.observer.observe(turboFrame, {
        childList: true,
        subtree: true
      })
    }
  }

  checkVisibility() {
    // Check if there are any document items in the turbo frame
    const turboFrame = this.element.closest('.files-container')?.querySelector('[id^="dossier_documents_"]')
    const hasDocuments = turboFrame?.querySelector('.bynn-hover-card') !== null

    if (hasDocuments) {
      this.element.classList.remove('d-none')
    } else {
      this.element.classList.add('d-none')
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}